import { Button, Modal } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react';
import * as apicall from '../../components/Apicall';
import { FaTrash } from 'react-icons/fa';


const Navbar = ({ hasUnreadMessages, resetNotifications }) => {
  const location = useLocation();

  const handleChatClick = () => {
    resetNotifications(); 
      toast.dismiss();
  };

  const isChatPage = location.pathname === '/chat';
const [notificationCount, setNotificationCount] = useState(0);
  const isStaffActive = ['/staff', '/staffForm', '/staffDetails'].some(path =>
    location.pathname.startsWith(path)
  );
  const [showModal,setShowModal]=useState(false)
  const[data,setData]=useState()
  const isEndUserActive = ['/user', '/userDetails'].some(path =>
    location.pathname.startsWith(path)
  );
  const [unreadBookingNotifIds, setUnreadBookingNotifIds] = useState([]); // array of IDs
  const isVendorActive = ['/vendor', '/vendorDetails'].some(path =>
    location.pathname.startsWith(path)
  );
  const isMasterDataActive = [
    'country',
    'state',
    'city',
    'memberShip',
    'masterData',
  ].some(path => location.pathname.includes(path));
  const isServiceActive = ['/service_offerings', '/service_offerings_form'].some(
    path => location.pathname.startsWith(path)
  );
  const isInquiriesActive = location.pathname.startsWith('/inquiries');
  const isCouponsActive = ['/coupon', '/couponDetails'].some(path =>
    location.pathname.startsWith(path)
  );
  const isAdsActive = location.pathname.startsWith('/ads');
  const isBookingActive = ['/bookings', '/bookingDetails','/orderdetails'].some(path =>
    location.pathname.startsWith(path)
  );
    const isPayout = ['/payout'].some(path =>
    location.pathname.startsWith(path)
  );
      const isFollowup = ['/followup'].some(path =>
    location.pathname.startsWith(path)
  );
  const isSupport = ['/support'].some(path =>
    location.pathname.startsWith(path)
  );
  const isSubscription = ['/subscriptions'].some(path =>
    location.pathname.startsWith(path)
  );
  const isMarketingActive = ['/marketing-campaign'].some(path =>
    location.pathname.startsWith(path)
  );
    const [booking, setBooking] = useState(null);
  const [bookingService, setBookingService] = useState(""); // <-- store booking's service
  const [currentStep, setCurrentStep] = useState(-1);

  const userDetails = JSON.parse(localStorage.getItem("user_details"));
const fetchNotificationCount = async () => {
    try {
      const res = await apicall.get('admin_notifications');
          const unreadNotifs = res?.data?.filter((notif) => notif.is_read === 0);
      
      setNotificationCount(unreadNotifs?.length)
      setUnreadBookingNotifIds(unreadNotifs.map((notif) => notif.id));
      setData(unreadNotifs)
    } catch (err) {
      console.error('Failed to fetch notifications');
    }
  };


  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };
const alertButton = async () => {
    setShowModal(true)
};

const handleClose = () =>{
  setShowModal(false)
}

    useEffect(() => {
          fetchNotificationCount();
           const interval = setInterval(fetchNotificationCount, 60000); 
  return () => clearInterval(interval);
    }, []);
const ViewDetails = async (booking_id, notifId) => {
  try {
    const response = await apicall.get(`admin_bookingDetails/${booking_id}`);
    const bookingData = response.data;
    setBooking(bookingData);
    setBookingService(bookingData.service_name);

    const status = bookingData.status;
    if (![1, 6, 7, 8].includes(status)) {
      const stepMap = { 2: 0, 3: 1, 9: 2, 4: 3, 5: 4 };
      setCurrentStep(stepMap[status] || 0);
    }

    // Mark notification as read
    await apicall.get(`updateReadStatus_adminportal/${notifId}`);
    setData(prev => prev.filter(item => item.id !== notifId));
    setNotificationCount(prev => Math.max(prev - 1, 0));

    // Hide modal first
    setShowModal(false);

    // Navigate after a short delay
    setTimeout(() => {
      navigate(`/bookingDetails/${booking_id}`, {
        state: { bookingData },
      });
    }, 100);
  } catch (error) {
    console.error("Error in ViewDetails:", error);
    toast.error("Failed to load booking details.");
  }
};


const handleDelete = async(id) =>{
  console.log(id,"chinni=>")
   try{
        const response = await apicall.get(`notification_delete/${id}`);
        console.log(response,"response")
        if(response.success){
          toast.success("Deleted Successfully");
          fetchNotificationCount();
        }
   }
     catch (error) {
    console.error("Error in ViewDetails:", error);
   }
}
const handleClearAll = async() =>{
   try{
        const response = await apicall.get(`delete_all_admin_notifications`);
        console.log(response,"response")
        if(response.success){
          toast.success("Deleted Successfully");
          setShowModal(false)
          setNotificationCount(0)
        }
   }
     catch (error) {
    console.error("Error in ViewDetails:", error);
   }
}
  return (
    
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container-fluid">
        <a className="navbar-brand" href="/services">
          <img
            src="/image/navbar_logo.png"
            alt="Logo"
            className="navbar-logo"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
  {userDetails?.role !== 2 && (
    <>
      <NavLink
        to="services"
        className={({ isActive }) =>
          isActive || isServiceActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Services
      </NavLink>

      {/* Users Dropdown */}
      <li className={`nav-item dropdown ${isStaffActive || isEndUserActive || isVendorActive ? 'active text-primary' : ''}`}>
        <div
          className="nav-link dropdown-toggle"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Users
        </div>
        <ul className="dropdown-menu">
          <NavLink
            to="staff"
            className={() =>
              isStaffActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            Staff
          </NavLink>
          <NavLink
            to="user"
            className={() =>
              isEndUserActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            End User
          </NavLink>
          <NavLink
            to="vendors"
            className={() =>
              isVendorActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            Vendor
          </NavLink>
        </ul>
      </li>

      {/* Data Dropdown */}
      <li className={`nav-item dropdown ${isMasterDataActive ? 'active text-primary' : ''}`}>
        <div
          className="nav-link dropdown-toggle"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Data
        </div>
        <ul className="dropdown-menu">
          <NavLink
            to="country"
            className={({ isActive }) =>
              isActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            Country
          </NavLink>
          <NavLink
            to="state"
            className={({ isActive }) =>
              isActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            State
          </NavLink>
          <NavLink
            to="city"
            className={({ isActive }) =>
              isActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            City
          </NavLink>
          <NavLink
            to="memberShip"
            className={({ isActive }) =>
              isActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            Membership Plans
          </NavLink>
          <NavLink
            to="masterData"
            className={({ isActive }) =>
              isActive
                ? 'dropdown-item active text-primary'
                : 'dropdown-item'
            }
          >
            Master Data
          </NavLink>
        </ul>
      </li>

      <NavLink
        to="inquiries"
        className={({ isActive }) =>
          isActive || isInquiriesActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Inquiries
      </NavLink>
      <NavLink
        to="ads"
        className={({ isActive }) =>
          isActive || isAdsActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Ads
      </NavLink>
      <NavLink
        to="coupons"
        className={({ isActive }) =>
          isActive || isCouponsActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Coupons
      </NavLink>
      <NavLink
        to="bookings"
        className={({ isActive }) =>
          isActive || isBookingActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Bookings
      </NavLink>
       <NavLink
        to="payout"
        className={({ isActive }) =>
          isActive || isPayout
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Vendor Payout
      </NavLink>
       <NavLink
        to="followup"
        className={({ isActive }) =>
          isActive || isFollowup
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        User FollowUp
      </NavLink>
       <NavLink
        to="support"
        className={({ isActive }) =>
          isActive || isSupport
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Support
      </NavLink>
       <NavLink
        to="subscriptions"
        className={({ isActive }) =>
          isActive || isSubscription
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Subscriptions
      </NavLink>
       <NavLink
        to="marketing-campaigns"
        className={({ isActive }) =>
          isActive || isMarketingActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Marketing
      </NavLink>
       <NavLink
    to="/chat"
    className="nav-link"
    onClick={handleChatClick}
  >
    Chat
    {!isChatPage && hasUnreadMessages && (
      <span className="notification-dot m-1" />
    )}
  </NavLink>
    </>
  )}

  {/* Always Show for role = 2 */}
  {userDetails?.role === 2 && (
    <>
      <NavLink
        to="coupons"
        className={({ isActive }) =>
          isActive || isCouponsActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Coupons
      </NavLink>
      <NavLink
        to="bookings"
        className={({ isActive }) =>
          isActive || isBookingActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Bookings
      </NavLink>
      <NavLink
        to="marketing-campaigns"
        className={({ isActive }) =>
          isActive || isMarketingActive
            ? 'nav-link active text-primary'
            : 'nav-link'
        }
      >
        Marketing
      </NavLink>
    </>
  )}


</ul>

 <div className="position-relative me-3" style={{ cursor: 'pointer' }} onClick={alertButton}>
  <FaBell size={20} />
  {notificationCount > 0 && (
    <span
      style={{
        position: 'absolute',
        top: -5,
        right: -10,
        background: 'red',
        color: 'white',
        borderRadius: '50%',
        fontSize: '12px',
        padding: '2px 6px',
        lineHeight: '1',
      }}
    >
      {notificationCount}
    </span>
  )}
</div>
<Modal show={showModal} onHide={() => setShowModal(false)} centered backdrop="static">
  <div className="p-4" style={{ maxHeight: '500px', overflowY: 'auto' }}>
    
    <div className="booking-header d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">Booking Details</h5>
       <div className="d-flex align-items-center gap-2">
    <button className="btn btn-sm btn-danger" 
    onClick={handleClearAll}
    >
      Clear All
    </button>
    <button className="btn-close" onClick={() => setShowModal(false)}></button>
  </div>
    </div>

    {data?.map((item, index) => (
      <div
        key={index}
        className="card mb-3 p-3 position-relative shadow-sm"
        style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}
      >
        {/* Delete Button */}
        <button
          className="btn btn-sm btn-outline-danger position-absolute"
          style={{ top: '10px', right: '10px' }}
          onClick={() => handleDelete(item?.id)}
        >
          <FaTrash />
        </button>

        <div className="info-row mb-2">
          <span className="label fw-bold">Booking Id:</span>{' '}
          <button
            className="btn btn-link p-0 ms-1"
  onClick={() => ViewDetails(item?.reference_id, item?.id)}
            style={{ textDecoration: 'underline', color: '#d01c4c' }}
          >
            {item?.reference_id}
          </button>
        </div>

        <div className="info-row mb-2">
          <span className="label fw-bold">User Id:</span>{' '}
          <span className="ms-1">{item?.user_id}</span>
        </div>

        <div className="info-row">
          <span className="label fw-bold">Status:</span>{' '}
          <span className="ms-1">{item?.title}</span>
        </div>
      </div>
    ))}
  </div>
</Modal>


          <Button
            className="btn primaryBackground text-white m-1 border-0"
            onClick={logout}
          >
            Logout
          </Button>
        </div>
      </div>
    </nav>
    
  );
};

export default Navbar;